import { PointInfo } from "../../WalltoFittingInfo";
import * as THREE from 'three';
import { WallGrid } from '../WallGrid';
import { ThreeView } from "../../../view3d/webcad";

/**
 * 壁の中点で軸平行にする
 * */
export class AxisParallelWall extends WallGrid {
    
    constructor(public pointList: PointInfo[]) {
        super(pointList);
    }

    public execute() {

        const x = new THREE.Vector3(1, 0, 0);
        const z = new THREE.Vector3(0, 0, 1);

        for (let i = 0; i < this.pointList.length; i+=2) {

            /** どちらの軸に平行な壁かを見て補正をかける */
            const p1 = this.pointList[i].point;
            const p2 = this.pointList[i+1].point;
            const wall = p2.clone().sub(p1);
            const center = wall.clone().divideScalar(2);
            const degree10 = 10;

            for (let j = 0; j < this.pointList.length; j+=2) {
                const midPoint = center.clone().add(p1);
                /** x軸に平行 */
                const rad = wall.clone().angleTo(x);
                console.log(THREE.MathUtils.radToDeg(rad));
                const deg = THREE.MathUtils.radToDeg(rad);
                if (deg <= degree10 || 170 <= deg) {
                    /** 中点からx軸に平行な線に近い壁を見つけて同時に補正 */
                    const y = midPoint.z;
                    if (midPoint.z - this.e < this.pointList[j].point.z && this.pointList[j].point.z < midPoint.z + this.e
                        && midPoint.z - this.e < this.pointList[j+1].point.z && this.pointList[j+1].point.z < midPoint.z + this.e) {
                        this.pointList[j].point.setZ(y);
                        this.pointList[j+1].point.setZ(y);
                        const indexList1 = this.clockwiseData[this.indexToGridList[j]];
                        indexList1.forEach((i: number) => this.pointList[i].point.setZ(y));
                        const indexList2 = this.clockwiseData[this.indexToGridList[j+1]];
                        indexList2.forEach((i: number) => this.pointList[i].point.setZ(y));
                    }
                }
                /** z軸に平行 */
                const rad_ = wall.clone().angleTo(z);
                console.log(THREE.MathUtils.radToDeg(rad_));
                const deg_ = THREE.MathUtils.radToDeg(rad_);
                if (deg_ <= degree10 || 170 <= deg_) {
                    /** 中点からz軸に平行な線に近い壁を見つけて同時に補正 */
                    const x = midPoint.x;
                    if (midPoint.x - this.e < this.pointList[j].point.x && this.pointList[j].point.x < midPoint.x + this.e
                        && midPoint.x - this.e < this.pointList[j+1].point.x && this.pointList[j+1].point.x < midPoint.x + this.e) {
                        this.pointList[j].point.setX(x);
                        this.pointList[j+1].point.setX(x);
                        const indexList1 = this.clockwiseData[this.indexToGridList[j]];
                        indexList1.forEach((i: number) => this.pointList[i].point.setX(x));
                        const indexList2 = this.clockwiseData[this.indexToGridList[j+1]];
                        indexList2.forEach((i: number) => this.pointList[i].point.setX(x));
                    }
                }
            }
        }

        
        // for (let i = 0; i < this.pointList.length; i+=2) {
        //     this.view(i, 0xff0000);
        // }

        return this.pointList;
        
    }

    private view(point: number, color) {
        const geometry = new THREE.SphereGeometry(0.1);
        const mesh = new THREE.Mesh(geometry, new THREE.MeshBasicMaterial({color: color}));
        mesh.position.set(this.pointList[point].point.x, 0, this.pointList[point].point.z);
        ThreeView.get().wcItemmgr.addLiDARShapes(mesh);
        mesh.userData = {index: point}
    }

    /** 
     * しきい値設定 
     * */
    public length(e: number) {
        this.e = e / 1000; /** 単位 mm → m */
    }
    

}